import { LoginData, AuthenticatedMonolithUser } from 'src/apis/monolith/types';
import { isServerError, useAxios } from 'src/hooks/use-axios';

const url = `${PRISMA_CONFIG.oldBackendUrl}/auth/login`;

export function useLogin() {
  const login = useAxios(
    (axios, signal, data: LoginData) =>
      axios.request<AuthenticatedMonolithUser>({
        signal,
        url,
        method: 'POST',
        data,
      }),
    {
      neededOnPageLoad: false,
      onError(error) {
        if (isServerError(error) && error.response.status === 500) {
          // note: bad credentials currently return as a 500 error
          // better: 400 and some generic flag to show that the input was wrong
          // even better: also add a specific flag to show that the input was wrong and
          // that it isn't a generic 400 error

          // bad credentials error looks like this:
          // - err.error.status: 500
          // - err.error.description: 'Bad credentials'
          // - err.error.errorCode : 'some generated number'

          // the description probably comes from spring security, so we can't rely on that
          // and need to treat every 500 error as a bad credentials error
          return error;
        } else if (isServerError(error) && error.response.status === 401) {
          // apparently new behaviour, but not rolled out to all stages, yet
          // for bad credentials you now get 401
          return error;
        } else {
          throw error;
        }
      },
    }
  );

  return login;
}
